import React, { useState } from 'react';
import './AdminLogin.css';

import { useHistory } from 'react-router-dom';

import axios from 'axios';
import { BASE_URL } from '../../constants';

const AdminLogin = (props) => {
	const { setBearerToken } = props;
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const history = useHistory();
	const handleSubmit = (event) => {
		event.preventDefault();
		axios
			.post(`${BASE_URL}auth/admin/login`, { email, password })
			.then((response) => {
				console.log(response.data.token);
				setBearerToken(response.data.token);
				history.push('/admin/dashboard');
			})
			.catch((error) => {
				console.log(error);
			});
	};
	return (
		<div className='AdminLogin container'>
			<h1>Admin Login</h1>
			<form className='col s12 container' onSubmit={handleSubmit}>
				<div className='row'>
					<div className='input-field col s12'>
						<input
							id='email'
							type='email'
							className='validate'
							value={email}
							onChange={(event) => setEmail(event.target.value)}
						/>
						<label htmlFor='email'>Email</label>
					</div>
				</div>
				<div className='row'>
					<div className='input-field col s12'>
						<input
							id='password'
							type='password'
							className='validate'
							value={password}
							onChange={(event) => setPassword(event.target.value)}
						/>
						<label htmlFor='password'>Password</label>
					</div>
				</div>
				<div className='row'>
					<button className='btn btn-wave'>Login</button>
				</div>
			</form>
		</div>
	);
};

export default AdminLogin;
